<template>
  <div class="code-tabs">
    <!-- Tabs -->
    <div class="tabs">
      <button
        v-for="(tab, index) in tabs"
        :key="tab.language"
        :class="{ active: activeIndex === index }"
        @click="activeIndex = index"
      >
        {{ tab.label }}
      </button>
    </div>

    <!-- 代码块 + 复制按钮 -->
    <div class="code-block-wrapper">
      <button class="copy-btn" @click="copyCode">
        {{ copied ? '已复制' : '复制代码' }}
      </button>
      <div class="code-block" v-highlight>
        <pre><code :class="'language-' + currentTab.language" v-html="currentTab.code"></code></pre>
      </div>
    </div>
  </div>
</template>

<script>
import hljs from 'highlight.js/lib/core'

// 按需引入语言
import javascript from 'highlight.js/lib/languages/javascript'
import python from 'highlight.js/lib/languages/python'
import java from 'highlight.js/lib/languages/java'
import c from 'highlight.js/lib/languages/cpp'

hljs.registerLanguage('javascript', javascript)
hljs.registerLanguage('python', python)
hljs.registerLanguage('java', java)
hljs.registerLanguage('c', c)

export default {
  name: 'CodeTabs',
  data() {
    return {
      activeIndex: 0,
      copied: false,
      tabs: [
        {
          label: 'JavaScript',
          language: 'javascript',
          code: hljs.highlight(`
import Ant from '@api/Ant';

Ant.sendSms1({
  account: '16000000',
  mobile: '8615800000000',
  msg: '[253] Your verification code is: 2530'
}, {
  sign: '1234abcd7890qwer',
  nonce: '1653043349000'
}).then(({ data }) => console.log(data));
          `.trim(), { language: 'javascript' }).value,
        },
        {
          label: 'Python',
          language: 'python',
          code: hljs.highlight(`
import requests

payload = {
  'account': '16000000',
  'mobile': '8615800000000',
  'msg': '[253] Your verification code is: 2530'
}
auth = {
  'sign': '1234abcd7890qwer',
  'nonce': '1653043349000'
}

response = requests.post('https://api.example.com/send', json=payload, headers=auth)
print(response.json())
          `.trim(), { language: 'python' }).value,
        },
        {
          label: 'Java',
          language: 'java',
          code: hljs.highlight(`
import java.util.HashMap;

public class SmsSender {
  public static void main(String[] args) {
    HashMap<String, String> payload = new HashMap<>();
    payload.put("account", "16000000");
    payload.put("mobile", "8615800000000");
    payload.put("msg", "[253] Your verification code is: 2530");  
    HashMap<String, String> auth = new HashMap<>();
    auth.put("sign", "1234abcd7890qwer");
    auth.put("nonce", "1653043349000");  
    System.out.println("Sending SMS: " + payload);
  }
}
          `.trim(), { language: 'java' }).value,
        },
        {
          label: 'C',
          language: 'c',
          code: hljs.highlight(`
#include <stdio.h>

int main() {
  char* account = "16000000";
  char* mobile = "8615800000000";
  char* msg = "[253] Your verification code is: 2530";
  char* sign = "1234abcd7890qwer";
  char* nonce = "1653043349000";  
  printf("Sending SMS to %s with message: %s\\n", mobile, msg);
  return 0;
}
          `.trim(), { language: 'c' }).value,
        }
      ]
    }
  },
  computed: {
    currentTab() {
      return this.tabs[this.activeIndex]
    }
  },
  methods: {
    copyCode() {
      const el = document.createElement('textarea')
      el.value = this.stripHtml(this.currentTab.code)
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.copied = true
      setTimeout(() => {
        this.copied = false
      }, 1000)
    },
    stripHtml(html) {
      const div = document.createElement('div')
      div.innerHTML = html
      return div.textContent || div.innerText || ''
    }
  }
}
</script>

<style scoped>
.code-tabs {
  background: #000; /* 全黑背景 */
  border-radius: 6px;
  overflow: hidden;
  font-family: 'Fira Code', 'Courier New', Courier, monospace;
}

.tabs {
  display: flex;
  background: #000;
  border-bottom: 1px solid #222;
}

.tabs button {
  padding: 10px 20px;
  border: none;
  background: transparent;
  color: #aaa;
  cursor: pointer;
  font-size: 14px;
  transition: 0.3s;
}

.tabs button.active {
  background-color: #111;
  color: #fff;
  font-weight: bold;
}

.code-block-wrapper {
  position: relative;
  background: #000;
}

.copy-btn {
  position: absolute;
  top: 8px;
  right: 12px;
  background: #222;
  color: #ccc;
  border: 1px solid #333;
  padding: 4px 10px;
  font-size: 12px;
  border-radius: 4px;
  cursor: pointer;
  z-index: 1;
}
.copy-btn:hover {
  background: #333;
}

.code-block {
  width: 500px;
  height: 270px;
  padding: 16px;
  background-color: #000;
  color: #fff;
  font-family: 'Fira Code', 'Courier New', Courier, monospace;
  border-radius: 4px;
  
}
 .code-block pre {
  width: 465px;
  height: 230px;
  background-color: rgba(29, 29, 29);
  border-color: #000;
  color: #fff !important; /* 字体白色 */
  margin: 0;
  padding: 10px;
  overflow: auto; 
}
/* WebKit 浏览器：Chrome、Edge、Safari */
.code-block pre::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.code-block pre::-webkit-scrollbar-thumb {
  background-color: #444;      /* 滚动条颜色 */
  border-radius: 3px;
}

.code-block pre::-webkit-scrollbar-track {
  background-color: #111;      /* 滚动轨道颜色 */
}
.code-block pre {
  scrollbar-width: thin;               /* Firefox 支持 */
  scrollbar-color: #444 #111;          /* thumb 和 track 颜色 */
}

.hljs {
  color: #fff; /* 默认字体颜色设为白色 */
  background: #000 !important;
}

.hljs-keyword,
.hljs-selector-tag,
.hljs-literal,
.hljs-section,
.hljs-link {
  color: #c678dd;
}

.hljs-function .hljs-keyword {
  color: #61afef;
}

.hljs-string {
  color: #98c379;
}

.hljs-number {
  color: #d19a66;
  border:1px solid red;
}

.hljs-comment {
  color: #5c6370;
  font-style: italic;
}

.hljs-variable,
.hljs-template-variable,
.hljs-attribute {
  color: #e06c75;
}

.hljs-title,
.hljs-type {
  color: #e5c07b;
}

</style>



// WEBPACK FOOTER //
// src/components/CodeTabs.vue